/*eslint-disable*/
import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
// core components
import styles from "assets/jss/material-kit-react/views/componentsSections/downloadStyle.js";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(styles);

export default function SectionDownload() {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <div className={classes.section}>
      <div className={classes.container}>
        <GridContainer className={classes.textCenter} justify="center">
          <GridItem xs={12} sm={4} md={4}>
            <img className={classes.triobanner} src={require("../../assets/img/landing1.png").default} alt="App Banner" />
          </GridItem>
          <GridItem xs={12} sm={8} md={8} style={{paddingTop:30}}>
          <h2 className={classes.title}>{t('landing1')}</h2>
          <h3 className={classes.description}>{t('landing2')}</h3>
          </GridItem>
        </GridContainer>
        <GridContainer className={classes.textCenter} justify="center">
          <GridItem xs={12} sm={4} md={4}>
            <img className={classes.triobanner} src={require("../../assets/img/landing2.png").default} alt="App Banner" />
          </GridItem>
          <GridItem xs={12} sm={8} md={8} style={{paddingTop:30}}>
          <h2 className={classes.title}>{t('landing3')}</h2>
          <h3 className={classes.description}>{t('landing4')}</h3>
          </GridItem>
        </GridContainer>
        <GridContainer className={classes.textCenter} justify="center">
          <GridItem xs={12} sm={4} md={4}>
            <img className={classes.triobanner} src={require("../../assets/img/landing3.png").default} alt="App Banner" />
          </GridItem>
          <GridItem xs={12} sm={8} md={8} style={{paddingTop:30}}>
          <h2 className={classes.title}>{t('landing5')}</h2>
          <h3 className={classes.description}>{t('landing6')}</h3>
          </GridItem>
        </GridContainer>
        <GridContainer className={classes.textCenter} justify="center">
          <GridItem xs={12} sm={4} md={4}>
            <img className={classes.triobanner} src={require("../../assets/img/landing4.png").default} alt="App Banner" />
          </GridItem>
          <GridItem xs={12} sm={8} md={8} style={{paddingTop:30}}>
          <h2 className={classes.title}>{t('landing7')}</h2>
          <h3 className={classes.description}>{t('landing8')}</h3>
          </GridItem>
        </GridContainer>
        <GridContainer className={classes.textCenter} justify="center">
          <GridItem xs={12} sm={4} md={4}>
            <img className={classes.triobanner} src={require("../../assets/img/landing5.png").default} alt="App Banner" />
          </GridItem>
          <GridItem xs={12} sm={8} md={8} style={{paddingTop:30}}>
          <h2 className={classes.title}>{t('landing9')}</h2>
          <h3 className={classes.description}>{t('landing10')}</h3>
          </GridItem>
        </GridContainer>
        <GridContainer className={classes.textCenter} justify="center">
          <GridItem xs={12} sm={4} md={4}>
            <img className={classes.triobanner} src={require("../../assets/img/landing6.png").default} alt="App Banner" />
          </GridItem>
          <GridItem xs={12} sm={8} md={8} style={{paddingTop:30}}>
          <h2 className={classes.title}>{t('landing11')}</h2>
          <h3 className={classes.description}>{t('landing12')}</h3>
          </GridItem>
        </GridContainer>

      </div>
    </div>
  );
}
